<template>
  <div class="out_wrap">
    <div class="flex_between mb22">
      <div class="left">
        <el-radio-group v-model="type" @change="typeChange">
          <el-radio-button label="全部" />
          <el-radio-button label="未读" />
          <el-radio-button label="已读" />
        </el-radio-group>
      </div>
      <div class="right">
        <el-button v-if="(type == '全部' || type == '未读') && tableData.length" type="primary" @click="read">全部已读</el-button>
      </div>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :total="pageControl.total"
      :page-size="pageControl.pageSize"
      :page-num="pageControl.page"
      @change="handlePageChange"
    >
      <!-- 内容 -->
      <!-- <template
        slot="is_read"
        slot-scope="{ row }"
      >
        <el-tag v-if="type == '全部' && row.is_read == 1" size="mini">未读</el-tag>
        <el-tag v-if="type == '全部' && row.is_read == 2" size="mini" type="info">已读</el-tag>
        {{ row.title }}
      </template> -->
      <!-- 状态 -->
      <template
        slot="is_read"
        slot-scope="{ row }"
      >
        <div :class="['msg_status', row.is_read == 1 ? 'unread' : '']">
          <span class="circle" />
          <span class="des">{{ row.is_read == 1 ? '未读' : '已读' }}</span>
        </div>
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="row.url" class="active_color" @click="showDetail(row)">点击查看</a>
      </template>
    </zf-table>
  </div>
</template>

<script>
import { noticeList, noticeallRead, noticeRead } from '@/api/common'
import ZfTable from '@/components/ZfTable/CoreTable'
import column from './columns'
import { mapActions } from 'vuex'
export default {
  components: {
    ZfTable
  },
  data() {
    return {
      column,
      type: '全部',
      pageControl: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      tableData: []
    }
  },
  created() {
    this.query(this.pageControl.page)
  },
  methods: {
    ...mapActions('user', ['getNoReadNotice']),
    query(pg) {
      this.pageControl.page = pg
      noticeList({
        page: pg,
        pageSize: this.pageControl.pageSize,
        is_read: this.type === '全部' ? '' : (this.type === '未读' ? 1 : 2)
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.data
          this.pageControl.total = res.data.total
        }
      })
    },
    typeChange(e) {
      this.query(1)
    },
    read() {
      noticeallRead().then(res => {
        if (res.code === 200) {
          this.query(1)
          this.getNoReadNotice()
        }
      })
    },
    showDetail(item) {
      if (!item.url) return
      if (item.is_read === 1) {
        noticeRead({ notice_id: item.notice_id }).then(res => {
          if (res.code === 200) {
            this.$router.push({ path: item.url })
            this.getNoReadNotice()
          }
        })
      } else {
        this.$router.push({ path: item.url })
      }
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.pageControl.page = pageNum
      this.pageControl.pageSize = pageSize
      this.query(this.pageControl.page)
    }
  }
}
</script>

<style lang="scss" scoped>
.msg_status{
  &.unread{
    .circle{
      background: #E70000;
    }
    .des{
      color: #E70000;
    }
  }
  .circle{
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #52C41A;
    color: #52C41A;
    border-radius: 100%;
  }
  .des{
    display: inline-block;
    margin-left: 8px;
    color: #52C41A;
  }
}
</style>
